import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FlyoutExternalsiteComponent } from '../../flyout/flyout-externalsite/flyout-externalsite.component';
import { FlyoutExternalsiteModule } from '../../flyout/flyout-externalsite/flyout-externalsite.module';
import { CommonService } from '../../services/common.service';
// This Module's Components
import { SocialIconsComponent } from './social-icons.component';

@NgModule({
  imports: [CommonModule, FlyoutExternalsiteModule, ModalModule.forRoot()],
  declarations: [SocialIconsComponent],
  exports: [SocialIconsComponent],
  providers: [CommonService]
})
export class SocialIconsModule {}
